/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NumberCircle07Icon16Solid = forwardRef('NumberCircle07Icon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Zm2.837-10.99H5.131v1.267h3.977A18.447 18.447 0 0 0 7.255 8.53C6.728 9.714 6.39 10.87 6.238 12h1.684a13.992 13.992 0 0 1 1.062-3.695c.535-1.22 1.153-2.271 1.853-3.153V4.011Z" })));
});
